import { render, staticRenderFns } from "./viewReminder.vue?vue&type=template&id=696daf5f&scoped=true&"
import script from "./viewReminder.vue?vue&type=script&lang=js&"
export * from "./viewReminder.vue?vue&type=script&lang=js&"
import style0 from "./viewReminder.vue?vue&type=style&index=0&id=696daf5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696daf5f",
  null
  
)

export default component.exports